import { Section } from './Section.jsx';
import { T } from '../T.jsx';

const AI_FEATURES = [
  {
    n: '01',
    titleKey: 'ml_ai_gen_title',
    title: 'Content Generation',
    descKey: 'ml_ai_gen_desc',
    desc: `Describe your topic and let AI draft slide content, talking points, and
      speaker notes. Refine with a single click or dive deeper into subtopics.`,
  },
  {
    n: '02',
    titleKey: 'ml_ai_format_title',
    title: 'Smart Formatting',
    descKey: 'ml_ai_format_desc',
    desc: `AI automatically applies best-practice layouts, adjusts typography, and
      balances visual elements to ensure every slide looks professional.`,
  },
  {
    n: '03',
    titleKey: 'ml_ai_translate_title',
    title: 'Live Translation',
    descKey: 'ml_ai_translate_desc',
    desc: `Present in any language. AI translates slide content and captions in
      real time, making your lectures accessible to international audiences.`,
  },
  {
    n: '04',
    titleKey: 'ml_ai_quiz_title',
    title: 'Quiz Generation',
    descKey: 'ml_ai_quiz_desc',
    desc: `Automatically generate quizzes from your lecture content. Multiple choice,
      short answer, and true/false questions aligned to learning objectives.`,
  },
  {
    n: '05',
    titleKey: 'ml_ai_summary_title',
    title: 'Lecture Summarization',
    descKey: 'ml_ai_summary_desc',
    desc: `After each session, AI generates concise summaries and key takeaways
      that students can review for study and revision.`,
  },
];

export function AiAssistant() {
  return (
    <Section>
      <section className="section" id="ai-assistant">
        <T k="ml_ai_label" className="section-label">AI-Powered</T>
        <T k="ml_ai_heading" as="h2" className="section-heading fade-in">
          Your Intelligent Lecture Assistant
        </T>
        <T k="ml_ai_intro" as="p" className="section-intro fade-in">
          MyLecture integrates advanced AI throughout the platform, helping you create
          better content, engage more students, and save hours of preparation time.
        </T>
        <div className="ai-features-list">
          {AI_FEATURES.map((f) => (
            <div className="ai-feature-item fade-in" key={f.n}>
              <div className="ai-feature-number">{f.n}</div>
              <div className="ai-feature-content">
                <T k={f.titleKey} as="h3">{f.title}</T>
                <T k={f.descKey} as="p">{f.desc}</T>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Section>
  );
}
